/**
 * The event names for logging.
 */
export enum EventNames {
    RECEIVED_FROM_SOLE_PANEL = 'Received from SolePanel',
    SENT_TO_SOLE_PANEL = 'Sent to SolePanel'
}
